module.exports = __webpack_public_path__ + "img/president_lincoln.d401f4af.jpg";